import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalComponent } from './modal.component';
import { ButtonModule } from '@nibtravel/shared/ui/components/button';
import { ShadowScrollModule } from '@nibtravel/shared/ui/directives/shadow-scroll';
import { IconModule } from '@nibtravel/shared/ui/components/icon';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    IconModule,
    ShadowScrollModule,
    A11yModule,
  ],
  exports: [ModalComponent],
  declarations: [ModalComponent],
})
export class ModalModule {}
